<template>
  <div class="card-body">
    <slot></slot>
  </div>
</template>
<script setup></script>
